import React from 'react';
import { ArrowUpRight, Quote } from 'lucide-react';

import './Press.css';
import { theme } from '../../theme/designSystem';
import { pressData } from '../../data/pressData';

function Press() {
    return (
        <section className="press section-pad" id="press" style={{ backgroundColor: theme.tertiary }}>
            <div className="container">
                <div className="press--header">
                    <span className="eyebrow">In the Press</span>
                    <h2 style={{ color: theme.primary }}>Featured &amp; profiled by the industry</h2>
                    <p style={{ color: theme.textSecondary }}>
                        Independent publications covering the engineering leadership and AI work behind
                        production-scale fleet systems.
                    </p>
                </div>

                <div className="press--grid">
                    {pressData.map((item) => (
                        <a
                            key={item.id}
                            href={item.url}
                            target="_blank"
                            rel="noreferrer"
                            className="press--card fade-in-up"
                            style={{ backgroundColor: theme.cardBg, borderColor: theme.border }}
                        >
                            <div className="press--top">
                                <span className="press--outlet" style={{ color: theme.primary }}>{item.outlet}</span>
                                <span className="press--kind">{item.kind}</span>
                            </div>

                            <h3 style={{ color: theme.primary }}>
                                <Quote className="press--quote-icon" size={18} />
                                {item.title}
                            </h3>
                            <p className="press--excerpt" style={{ color: theme.textSecondary }}>{item.excerpt}</p>

                            <div className="press--foot">
                                <span style={{ color: theme.textTertiary }}>{item.author} · {item.date}</span>
                                <span className="press--read">
                                    Read <ArrowUpRight size={15} />
                                </span>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Press;
